import { createRoutine } from 'redux-saga-routines';

export const toggleProfilePicRequired = createRoutine('TOGGLE_PROFILE_PIC_REQUIRED');
export const syncProfile = createRoutine('SYNC_PROFILE');
export const stopSyncingProfile = createRoutine('STOP_SYNCING_PROFILE');
